"use client";

import {
  HoverPrefetchLink,
  type HoverPrefetchLinkProps,
} from "@/components/ui/hover-prefetch-link";
import { isAdminHref, useOpenableHref } from "@/hooks/use-openable-href";

export function AdminHoverPrefetchLink(props: HoverPrefetchLinkProps) {
  const href = typeof props.href === "string" ? props.href : undefined;
  if (href !== undefined && isAdminHref(href)) {
    return <GatedHoverPrefetchLink {...props} href={href} />;
  }
  return <HoverPrefetchLink {...props} />;
}

function GatedHoverPrefetchLink(props: HoverPrefetchLinkProps & { href: string }) {
  const openable = useOpenableHref(props.href);
  if (openable === undefined) return <span className={props.className}>{props.children}</span>;
  return <HoverPrefetchLink {...props} />;
}
